import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack, IoMdClose } from "react-icons/io";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginUser } from '../../utils/wellspoken.api'
//import img from '../../assests/loginimg.svg'

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isForGotPass, setIsForGotPass] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!loginEmail.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(loginEmail)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!loginPassword.trim()) {
      newErrors.password = "Password is required";
    } else if (loginPassword.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // Stop API call if validation fails
    }

    setLoading(true);

    const payload = {
      EamilId: loginEmail,
      Password: loginPassword,
      entityId: 2,
    };

    try {
      const data = await loginUser(payload);

      login({
        token: data.token,
        user: {
          id: data.userId,
          name: data.name,
          email: loginEmail,
          mobile: data.mobile,
          isActive: data.isActive,
          isApproval: data.isApproval
        }
      });

      toast.success("Login successful");
      navigate("/dashboard/profile");
    } catch (error) {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };


  const handleForgot = () => {
    setIsForGotPass(false);
  };

  return (
    <section
      className="relative w-full min-h-screen flex items-center justify-center
               bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50
               overflow-hidden"
      aria-labelledby="login-heading"
    >
      {/* ===== BACKGROUND IMAGE (DESKTOP ONLY) ===== */}
      <div
        className="hidden lg:flex absolute inset-0 items-center justify-center"
        aria-hidden="true"
      >
        <img
          src="/images/loginimg1.svg"
          alt="login image"
          className="max-w-[1100px] w-full object-contain"
          loading="lazy"
        />
      </div>

      {/* ===== BACK BUTTON ===== */}
      <Link
        to="/"
        className="absolute top-4 left-4 z-20
                 inline-flex items-center justify-center
                 rounded-full border p-2
                 bg-white/80 backdrop-blur
                 hover:bg-white"
        aria-label="Go back to home"
      >
        <IoMdArrowRoundBack className="size-6 text-gray-700" />
      </Link>

      {/* ===== LOGIN CARD ===== */}
      <main
        className="relative z-10
                 w-full max-w-md
                 lg:absolute lg:right-[12%]
                 px-4 sm:px-6"
      >
        <div
          className="bg-white/95 backdrop-blur-xl
                   rounded-2xl
                   border border-gray-200
                   shadow-[0_30px_80px_-20px_rgba(0,0,0,0.25)]
                   p-6 sm:p-8  min-h-[440px] lg:min-h-[440px]"
        >
          <header className="mb-6 text-center">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
              Log in to your account
            </h1>
          </header>

          <form onSubmit={handleSubmit} className="space-y-5" noValidate>
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <input
                type="email"
                value={loginEmail}
                onChange={(e) => {
                  setLoginEmail(e.target.value);
                  setErrors({ ...errors, email: "" });
                }}
                className={`mt-1 w-full rounded-lg border px-4 py-2.5
      ${errors.email
                    ? "border-red-500 focus:ring-red-200"
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-200"
                  }`}
                placeholder="you@example.com"
              />
              {errors.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>


            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={loginPassword}
                  onChange={(e) => {
                    setLoginPassword(e.target.value);
                    setErrors({ ...errors, password: "" });
                  }}
                  className={`mt-1 w-full rounded-lg border px-4 py-2.5
        ${errors.password
                      ? "border-red-500 focus:ring-red-200"
                      : "border-gray-300 focus:border-blue-500 focus:ring-blue-200"
                    }`}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2
                 text-sm text-gray-500 hover:text-blue-600"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>

              {errors.password && (
                <p className="text-red-500 text-xs mt-1">{errors.password}</p>
              )}
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-full font-semibold text-white
                       bg-gradient-to-r from-blue-600 to-indigo-600
                       hover:from-blue-500 hover:to-indigo-500
                       transition-all disabled:opacity-60"
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            {/* Footer */}
            <p className="text-center text-xs text-gray-500">
              © {new Date().getFullYear()}{" "}
              <span className="font-semibold text-gray-900">
                Well Spoken
              </span>
              . All rights reserved.
            </p>
          </form>
        </div>
      </main>

      <ToastContainer />
    </section>
  );

};

export default Login;
